import { callOrganizationServiceApi } from '../../../apis/organizationService';

/**
 * Every zip one sales metro owns, from organization-service. Unpaged: the
 * handler answers the whole set in one body.
 *
 * An unknown or malformed id is a 404 `sales_metro_not_found`; the reserved
 * Unassigned metro owns no zips and answers `[]`.
 *
 * @param {string} salesMetroId
 * @returns {Promise<import('../types/SalesMetro.api').ISalesMetroZipsApiResponse>}
 */
export const getSalesMetroZips = (salesMetroId) =>
  callOrganizationServiceApi('get', `admin/sales-metros/${salesMetroId}/zips`);
